export default "__VITE_ASSET__BTUL9EPP__"